(function (angular) {
    'use strict';

    angular.module('shared')
        .controller('emailValidationCtrl', ['$scope', '$stateParams', '$location', 'jwtService',
            function ($scope, $stateParams, $location, jwtService) {

                var accountId = $stateParams.accountId;
                var queryParams = {
                    code: $location.search().code,
                    emailType: $location.search().type,
                    userId: parseInt($location.search().user, 10)
                };

                $scope.validating = true;
                if (queryParams.code && queryParams.code.length > 0 && queryParams.emailType && queryParams.emailType.length > 0 && queryParams.userId) {
                    jwtService.validateEmail(accountId, queryParams)
                        .then(function (result) {
                            $scope.failure = false;
                        })
                        .catch(function (error) {
                            $scope.failure = {
                                message: error.data.validationFailures || "Something went wrong"
                            };
                        })
                        .finally(function () {
                            $scope.validating = false;
                        });
                } else {
                    $scope.validating = false;
                    $scope.failure = {
                        message: "Link is not valid - check if it was copied properly."
                    };
                }


            }]);

})(window.angular);
